<template>
  <v-card
    @click="() => typeof widget.data.link!=='undefined' ? move(widget.data.link) : typeof widget.data.dialog!=='undefined' ? emitDialog(widget.data.dialog) : null"
    v-if="widget.type==='tile' && widget.data.template==='defaultIconLeftDesign'"
    :style="widget.data.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79)' : widget.data.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335)' : widget.data.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443)' : widget.data.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000)' : 'background:' + widget.data.color "
    dark
    :height="widget.data.iconHeight+23"
  >

    <div
      :style="'position: absolute ; left: 10px ;top: 10px ; height: ' + widget.data.iconHeight + 'px ; width:' + widget.data.iconWidth + 'px ; float: left ; overflow: hidden ; border-radius:15px '">
      <v-img
        :max-height="widget.data.iconHeight"
        :max-width="widget.data.iconWidth"
        contain
        :src="getImage(widget.data.icon)"
      ></v-img>
    </div>
    <v-card-title class="text-h5" style=" position: absolute ; padding-left: 110px !important; font-size: 20px !important;" v-html="widget.data.title">

    </v-card-title>
    <v-card-actions style=" position: relative ; top: 60px"  v-if="widget.data.model!=='no'">
      <v-btn text v-if="widget.data.model!==''">
        {{ widget.data.model }} {{ widget.data.prefix }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import router from "@/router";
import {getImage} from '@/../src/views/generator/page-handler'

export default {
  name: "tile-icon-left-default-design",
  data(){
    return {
      getImage:getImage
    }
  },
  props: {
    widget: Object
  },
  methods: {
    move(link) {
      let result = link.includes("http");
      if (result) {
        window.location.href = link
      } else {
        router.push(link)
      }
    },
    emitDialog(dialog){
      this.$emit('open-dialog', dialog)
    }
  }
}
</script>

<style scoped>

</style>
